import React, { useState, useEffect, useRef } from "react";
import { TextField, Grid, Paper, Typography, Button, Backdrop, CircularProgress, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InputMask from "react-input-mask";
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';
import { MobileNumberValidation } from "../utils/MobileNumberCheck";

function CustomerRepresenterForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [customerRepresenterCode, setCustomerRepresenterCode] = useState('');
    const [friendMobileNumber, setFriendMobileNumber] = useState('');

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset'
            }, "& .MuiSvgIcon-root": {
                position: 'inherit'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0"
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    useEffect(() => {
        setOpen(true);
        axios.get('/api/v1/Profile/GetCustomerRepresenterCode', {
            params: {
                customerId: getAuthenticationToken().userID
            }
        }).then((res) => {
            setCustomerRepresenterCode(res.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        let mobileObject = MobileNumberValidation(friendMobileNumber);
        if (mobileObject.isValid) {
            setOpen(true);
            axios.post('/api/v1/Profile/SendCustomerRepresenterCodeToFriend', null,
                {
                    params: {
                        CustomerId: getAuthenticationToken().userID,
                        FriendMobileNumber: friendMobileNumber
                    }
                }
            ).then(response => {
                setMessageNotify({
                    severity: "success",
                    message: "کد معرف با موفقیت ارسال شد",
                    open: true
                });
            }).catch((e) => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ارسال اطلاعات به سرور",
                    open: true
                });
            }).finally(() => {
                setOpen(false);
            })
        }
        else{
            setMessageNotify({
                severity: "warning",
                message: "شماره تلفن همراه به صورت صحیح وارد نشده است",
                open: true
            });
            
        }
    }

    return (<>
        <Alert variant="filled" severity="info" icon={false} style={{ marginBottom: '10px' }}>
            شماره تلفن همراه دوستان را جهت دعوت به باشگاه مشتریان NEC وارد کنید و با ثبت نام ایشان امتیاز کسب کنید
        </Alert>
        <form onSubmit={handleSubmit}>
            <Paper elevation={10} style={paperStyle} >
                <Typography variant="h6" gutterBottom>
                    معرفی باشگاه مشتریان NEC به دوستان
                </Typography>
                <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}> کد معرف شما: </span><span style={{ fontSize: '1.2rem', padding: '8px', border: '1px solid #790054', borderRadius: '1.3rem' }}>{customerRepresenterCode}</span>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <InputMask
                            mask="99999999999"
                            maskChar=" "
                            value={friendMobileNumber}
                            onChange={e => setFriendMobileNumber(e.target.value)}
                        >
                            {() => <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="postalCode"
                                name="postalCode"
                                label="شماره همراه دوست"
                                fullWidth
                                variant="standard" />}
                        </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button
                            id="submit"
                            type='submit'
                            name="submit"
                            fullWidth
                            variant="contained"
                            color="success" >ارسال کد معرف به صورت پیامک</Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button
                            onClick={() => { props.history.push('/') }}
                            id="cancel"
                            name="cancel"
                            fullWidth
                            variant="outlined"
                            color="error" >انصراف</Button>
                    </Grid>
                </Grid>
            </Paper>
        </form>
        <MaterialNotifyComponent open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </>
    );
}

export default withRouter(CustomerRepresenterForm);